module.exports = __webpack_public_path__ + "img/UU.f6c85da7.png";